/**
 * Copyright © Binary Anvil, Inc. All rights reserved.
 * See https://binaryanvil.com/software/license for license details.
 */
export const triggerEvent = (eventData: {
    type: string,
    details?: any,
}) => {
    if (typeof window !== undefined) {
        const event = new CustomEvent(eventData.type, {
            detail: eventData.details,
        });
        window.dispatchEvent(event)
    }
};
